// Sends the lead conversion once the server has confirmed the submission.
// The Google Ads event is defined in includes/ga4.php; the dataLayer event
// gives GTM a stable trigger without exposing any user-entered field values.
function trackContactConversion(form) {
    try {
        const sourcePageField = form.elements.namedItem('source_page');
        const sourcePage = sourcePageField && sourcePageField.value ? sourcePageField.value : '';
        const isHomepage = sourcePage === 'home';
        const isHero = sourcePage === 'hero';
        const topicField = form.elements.namedItem('topic');
        const sourceField = form.elements.namedItem('source');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'contact_form_submit',
            form_id: form.id || 'contact-form',
            form_location: isHero ? 'hero' : (isHomepage ? 'homepage' : 'contact_page'),
            form_topic: topicField && topicField.value ? topicField.value : '',
            form_referral_source: sourceField && sourceField.value ? sourceField.value : '',
            page_path: window.location.pathname || '/'
        });

        if (typeof window.gtag_report_conversion === 'function') {
            window.gtag_report_conversion();
        }
    } catch (error) {
        // Analytics must never interfere with the form flow.
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const forms = Array.from(document.querySelectorAll('form#contact-form, form#contact-enquiry-form, form#hero-contact-form'));

    forms.forEach((form) => {
        const sourcePageField = form.elements.namedItem('source_page');
        const sourcePage = sourcePageField && sourcePageField.value ? sourcePageField.value : '';
        const isHomepage = sourcePage === 'home';
        const isHero = sourcePage === 'hero';
        const container = form.parentElement;

        const success = (container && container.querySelector('[data-contact-success]')) || document.getElementById('contact-success');
        if (!success) return;

        const submitButton = form.querySelector('button[type="submit"]');
        let alertBox = (container && container.querySelector('[data-contact-alert]')) || document.getElementById('contact-form-alert');

        if (!alertBox) {
            alertBox = document.createElement('div');
            alertBox.id = 'contact-form-alert';
            alertBox.className = 'contact-form-alert';
            alertBox.setAttribute('role', 'alert');
            alertBox.setAttribute('aria-live', 'assertive');
            alertBox.hidden = true;
            form.parentNode.insertBefore(alertBox, form);
        }

        const resetButton = (container && container.querySelector('[data-contact-reset]')) || document.getElementById('contact-reset');

        function getField(name) {
            return form.elements.namedItem(name);
        }

        function setVisible(element, visible) {
            element.hidden = !visible;
            element.classList.toggle('hidden', !visible);
        }

        function setErrorVisible(error, visible) {
            error.hidden = !visible;
            error.classList.toggle('hidden', !visible);
        }

        function getErrorElement(name, field) {
            let error = form.querySelector('[data-error-for="' + name + '"]');
            if (error) return error;

            const consentContainer = field && field.closest('.contact-consent');
            if (consentContainer) {
                error = document.createElement('small');
                error.className = 'contact-error contact-field-error contact-consent-error';
                error.setAttribute('data-error-for', name);
                error.setAttribute('role', 'alert');
                consentContainer.insertAdjacentElement('afterend', error);
                return error;
            }

            const container = field && (field.closest('.contact-field') || field.closest('.contact-input'));
            if (!container) return null;

            error = container.querySelector('.contact-error, .contact-field-error');
            if (!error) {
                error = document.createElement('small');
                error.className = 'contact-error contact-field-error';
                error.setAttribute('role', 'alert');
                container.appendChild(error);
            }
            return error;
        }

        function clearErrors() {
            alertBox.hidden = true;
            alertBox.textContent = '';
            form.querySelectorAll('.contact-error, .contact-field-error').forEach((error) => {
                setErrorVisible(error, false);
                error.textContent = '';
            });
            form.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
                field.removeAttribute('aria-invalid');
            });
        }

        function showErrors(errors) {
            Object.entries(errors || {}).forEach(([name, message]) => {
                const field = getField(name);
                const error = field ? getErrorElement(name, field) : null;
                if (error) {
                    error.textContent = message;
                    setErrorVisible(error, true);
                }
                if (field) field.setAttribute('aria-invalid', 'true');
            });
        }

        function validateClient() {
            const errors = {};
            const name = getField('name');
            const email = getField('email');
            const phone = getField('phone');
            const message = getField('message');
            const consent = getField('consent');
            const source = getField('source');
            const topic = getField('topic');
            const subject = getField('subject');
            const phonePattern = /^\d{10}$/;

            if (!name || !name.value.trim()) errors.name = 'Please enter your name.';
            if (!phone || !phone.value.trim() || !phonePattern.test(phone.value.trim())) errors.phone = 'Please enter a valid 10-digit mobile number.';

            if (isHero) {
                if (!topic || !topic.value) errors.topic = 'Please select a type of MLM software.';
                return errors;
            }

            if (!email || !email.value.trim() || !email.checkValidity()) errors.email = 'Please enter a valid email address.';
            if (!message || !message.value.trim()) errors.message = isHomepage ? 'Please write a message.' : 'Please tell us a little about your requirements.';
            if (isHomepage && (!source || !source.value)) errors.source = 'Please tell us how you heard about us.';
            if (!isHomepage && (!topic || !topic.value)) errors.topic = 'Please select a topic.';
            if (subject && subject.value.length > 100) errors.subject = 'Please enter a shorter subject.';
            if (consent && !consent.checked) errors.consent = 'Please confirm that we may use your details to reply.';

            return errors;
        }

        async function submitForm(event) {
            event.preventDefault();
            clearErrors();

            const clientErrors = validateClient();
            if (Object.keys(clientErrors).length) {
                showErrors(clientErrors);
                alertBox.textContent = 'Please check the highlighted fields.';
                alertBox.hidden = false;
                const firstError = form.querySelector('[aria-invalid="true"]');
                if (firstError) firstError.focus();
                return;
            }

            submitButton.disabled = true;
            submitButton.setAttribute('aria-busy', 'true');

            try {
                const response = await fetch(form.dataset.endpoint || form.action || 'contact-submit.php', {
                    method: 'POST',
                    body: new FormData(form),
                    headers: { Accept: 'application/json' },
                });
                const result = await response.json();

                if (!response.ok || !result.success) {
                    if (result.errors) showErrors(result.errors);
                    alertBox.textContent = result.message || 'Please check the highlighted fields.';
                    alertBox.hidden = false;
                    const firstError = form.querySelector('[aria-invalid="true"]');
                    if (firstError) firstError.focus();
                    return;
                }

                // Track before reset() clears the topic/source fields.
                trackContactConversion(form);

                form.reset();
                setVisible(form, false);
                setVisible(success, true);
                success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } catch (error) {
                alertBox.textContent = 'We could not submit your enquiry right now. Please try again or email us directly.';
                alertBox.hidden = false;
            } finally {
                submitButton.disabled = false;
                submitButton.removeAttribute('aria-busy');
            }
        }

        form.addEventListener('submit', submitForm);

        form.addEventListener('input', (event) => {
            const field = event.target;
            const error = getErrorElement(field.name, field);
            if (error) {
                setErrorVisible(error, false);
                error.textContent = '';
            }
            field.removeAttribute('aria-invalid');
            if (!alertBox.hidden) {
                alertBox.hidden = true;
                alertBox.textContent = '';
            }
        });

        form.addEventListener('change', (event) => {
            const field = event.target;
            const error = getErrorElement(field.name, field);
            if (error) {
                setErrorVisible(error, false);
                error.textContent = '';
            }
            field.removeAttribute('aria-invalid');
        });

        if (resetButton && (isHomepage || isHero)) {
            resetButton.addEventListener('click', () => {
                form.reset();
                clearErrors();
                setVisible(success, false);
                setVisible(form, true);
            });
        }
    });
});
